import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { Router, NavigationExtras } from '@angular/router';
import { ConfirmDialogModel, ConfirmationDialogComponent } from 'src/app/confirmation-dialog/confirmation-dialog.component';
import { UserSubscriptionDilogComponent } from '../user-subscription-dilog/user-subscription-dilog.component';
import { DatePipe } from '@angular/common';
import { takeUntil, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';

@Component({
  selector: 'app-admin-wms-users',
  templateUrl: './admin-wms-users.component.html',
  styleUrls: ['./admin-wms-users.component.scss']
})

export class AdminWmsUsersComponent implements OnInit, OnDestroy {
  private ResponseVerifiedAdminWmsUserList: Subject<any> = new Subject();
  private searchWmsUsersSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  Limit = 10;
  search = '';
  offset: any = 0;
  page = 1;
  dataObject: { search: any; limit: any; offset: any; };
  adminWmsUserList: any;
  epcId: any;
  role: any;
  wmsUserDeviceList: any = [];
  count: any;
  deviceObject: { user_id: any; };
  closeResult: string;
  selectedUserId: any;
  selectedNormalUserId: any;
  userChangePasswordRequestObject: { user_id: any; new_password: any; confirm_password: any; };
  pipe = new DatePipe('en-US');
  SadminAccess: any = [];
  access: any;

  constructor(private dialog: MatDialog, private dashbord: DashboardService, private toastr: ToastrService,
    private router: Router, private modalService1: NgbModal,) {
    this.role = localStorage.role;
    this.epcId = localStorage.id;
  }

  ngOnInit() {

    this.SadminAccess = JSON.parse(localStorage.getItem('SadminAccess') || '[]');

    if (localStorage.SadminAccess != undefined) {
      this.SadminAccess.forEach(x => {
        if (x.menu_name == 'User Registration') {
          this.access = x.access;

        }
      });
    }
    this.getAllAdminWmsUserList(this.search, this.Limit, this.offset);
    this.searchAllWmsUsers();
  }

  editWmsUser(userId) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'id': userId,
      }
    };
    this.router.navigate(['/inject-solar/add-admin-wms-users/'], navigationExtras);
  }

  // EDIT DEVICE
  EditDevice(userId, epc_id, is_emeter) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'id': userId,
        'epc_id': epc_id,
        'is_emeter': is_emeter
      }
    };
    this.router.navigate(['/inject-solar/register-wmsusers-device-byadmin'], navigationExtras);
  }

  // page change
  nextPage(pageIndex): void {
    this.offset = (pageIndex - 1) * 10;
    this.getAllAdminWmsUserList(this.search, this.Limit, this.offset);
  }
  // get All Admin Wms_user List
  getAllAdminWmsUserList(search, limit, offset) {
    if (offset == 0) {
      this.page = 1;
    }
    this.dataObject = {
      search: search,
      limit: limit,
      offset: offset
    };
    this.dashbord.getAllAdminWmsUserList(this.dataObject)
      .pipe(takeUntil(this.ResponseVerifiedAdminWmsUserList))
      .subscribe(
        async data => {
          this.adminWmsUserList = [];
          this.count = 0;
          if (data.status) {
            this.count = data.count;
            this.adminWmsUserList = data.resultObject;
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);

            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  searchAllWmsUsers() {
    this.searchWmsUsersSubject.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this.destroy$),
      tap(searchValue => {
        this.search = searchValue;
        this.getAllAdminWmsUserList(this.search, 10, 0);
      })
    ).subscribe();
  }

  onSearchWmsUsers(event: KeyboardEvent) {
    this.searchWmsUsersSubject.next((event.target as HTMLInputElement).value.trim() || "");
  }


  viewDevice(viewDevices, userId) {
    this.wmsUserDeviceList = [];
    this.getDeviceForwmsUser(userId);
    this.modalService1.open(viewDevices, { size: <any>'xl' });
  }

  // get devices by user id
  getDeviceForwmsUser(userId) {
    this.deviceObject = {
      user_id: userId,
    };
    this.dashbord.getAdminWmsUserDevicesById(this.deviceObject)
      .pipe(takeUntil(this.ResponseVerifiedAdminWmsUserList))
      .subscribe(
        async data => {
          this.wmsUserDeviceList = [];
          if (data.status) {
            this.wmsUserDeviceList = data.device_info;
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // change password modal start
  openResetPasswordDialog(content, id) {
    this.selectedUserId = id;
    this.modalService1.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  // change password by userid Normal User
  changePasswordByUserId(formData) {
    this.userChangePasswordRequestObject = {
      user_id: this.selectedUserId,
      new_password: formData.value.newPassword,
      confirm_password: formData.value.confirmPassword
    };
    this.dashbord.changePasswordNormalAndWmsByUserId(this.userChangePasswordRequestObject)
      .pipe(takeUntil(this.ResponseVerifiedAdminWmsUserList))
      .subscribe(
        async data => {
          if (data.status) {
            this.toastr.success('Password Changed Successfully!!');
            this.modalService1.dismissAll();
            this.getAllAdminWmsUserList(this.search, this.Limit, this.offset);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // user delete dilog box
  public confirmDialog(id: any): void {
    let message = "Are you sure you want to delete this User?";
    let title = "Confirm Action";
    const dialogData = new ConfirmDialogModel(title, message);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteWmsUserById(id);
      }
    });
  }

  // change password by userid Normal User
  deleteWmsUserById(id) {
    var deleteWmsUser = {
      "user_id": id,
    };
    this.dashbord.deleteWmsUserByAdmin(deleteWmsUser)
      .pipe(takeUntil(this.ResponseVerifiedAdminWmsUserList))
      .subscribe(
        async data => {
          if (data.status) {
            this.toastr.success('User deleted successfully!!');
            this.getAllAdminWmsUserList(this.search, this.Limit, this.offset);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // renew user subscription dilog box
  public confirmRenewDialog(id: any): void {
    const dialogRef = this.dialog.open(UserSubscriptionDilogComponent, {
      width: '400px',
      data: id

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        if (result.start_date != undefined && result.start_date != "" && result.start_date != null && result.end_date != "" && result.end_date != undefined && result.end_date != null) {
          this.renewSubscriptionUser(id, result);
        }
      }
    });
  }

  // renew user by id
  renewSubscriptionUser(id, result) {
    var subscriptionNormalUserObj = {
      user_id: id,
      start_dt: this.pipe.transform(result.start_date, "yyyy-MM-dd"),
      end_year: result.end_date
    };
    this.dashbord.adminWmsUserSubscription(subscriptionNormalUserObj)
      .pipe(takeUntil(this.ResponseVerifiedAdminWmsUserList))
      .subscribe(
        async data => {
          if (data.status) {
            this.toastr.success(data.message);
            this.getAllAdminWmsUserList(this.search, this.Limit, this.offset);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // distroy subscription
  ngOnDestroy() {
    this.ResponseVerifiedAdminWmsUserList.next();
    this.ResponseVerifiedAdminWmsUserList.complete();
    this.destroy$.next();
    this.destroy$.complete();

    this.searchWmsUsersSubject.next();
    this.searchWmsUsersSubject.complete();

  }

}
